import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Home from "./pages/Home/home";
import SuccessStories from "./pages/SuccessStories";
import About from "./pages/About";
import Blog from "./pages/Blog";
import ContactUs from "./pages/ContactUs";
import FAQs from "./pages/FAQs";
import KnowledgeBase from "./pages/KnowledgeBase";
import Support from "./pages/Support";
import Footer from "./pages/Home/components/Footer";
import ItSupport from "./pages/services/Pages/itSupport";
import CloudSolutions from "./pages/services/Pages/cloudSolutions";
import FinancialSolutions from "./pages/services/Pages/financialSolutions";
import BackupAndRecovery from "./pages/services/Pages/backupAndRecovery";
import OldAndSlow from "./pages/challanges/Pages/oldAndSlow";
import CyberSecurity from "./pages/services/Pages/cyberSecurity";
import MobileSecurity from "./pages/services/Pages/mobileSecurity";
import Communications from "./pages/services/Pages/communications";
import DoesItSecurityMatter from "./pages/challanges/Pages/doesItSecurityMatter";
import DisasterRecovery from "./pages/challanges/Pages/disasterRecovery";
import ItAndRoi from "./pages/challanges/Pages/itAndRoi";
import SmallIssues from "./pages/challanges/Pages/smallIssues";
import Terms from "./pages/Terms";
import Privacy from "./pages/privacy";
import NotFound from "./pages/notFound";
import TermsSaveHunge from "./pages/TermsSavehunger";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/Products" element={<KnowledgeBase />} />
        <Route path="/success-stories" element={<SuccessStories />} />
        <Route path="/support" element={<Support />} />
        <Route path="/faqs" element={<FAQs />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/termsSaveHunger" element={<TermsSaveHunge />} />
        <Route path="/services/it-support" element={<ItSupport />} />
        <Route path="/services/cyber-security" element={<CyberSecurity />} />
        <Route
          path="/services/cyber-security/mobile-security"
          element={<MobileSecurity />}
        />
        <Route path="/services/cloud-solutions" element={<CloudSolutions />} />
        <Route
          path="/services/financial-solutions"
          element={<FinancialSolutions />}
        />
        <Route
          path="/services/backup-recovery"
          element={<BackupAndRecovery />}
        />
        <Route
          path="/challenges/old-slow-and-useless"
          element={<OldAndSlow />}
        />
        <Route path="/services/communications" element={<Communications />} />
        <Route
          path="/challenges/it-security-does-it-matter"
          element={<DoesItSecurityMatter />}
        />
        <Route
          path="/challenges/disaster-recovery-whats-that"
          element={<DisasterRecovery />}
        />
        <Route path="/challenges/it-and-roi" element={<ItAndRoi />} />
        <Route
          path="/challenges/small-issues-which-create-big-problems"
          element={<SmallIssues />}
        />
        <Route path="/terms" element={<Terms />} />
        {/* <Route path="/privacy" element={<Privacy />} /> */}

        {/* <Route path="/privacy" element={<Privacy />} /> */}

        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}
//comment //

export default App;
